import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import TopNavigation from "../../../components/TopNavigation";
import * as Assets from "../../../utils/svg_assets";
import "./style.scss";
import { Row, Col, ListGroup, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import HeaderLayout, { DefaultLeading } from "../../../components/HeaderLayout";
import { useParams } from "react-router";
import ApiUtils from "../../../utils/api_utils";
import ShowGoogleMap from "../../../components/ShowGoogleMap";

export const DiscountItem = ({ data, url_category }) => {
  const navigate = useNavigate();
  let voucherPathDetail = `/reward/discount/${url_category}/detail/${data.reward}`;
  let voucher = data;

  return (
    <ListGroup.Item>
      <Row>
        <Col xs={3} sm={3} md={3} className="div-voucher-list">
          <img
            src={
              voucher.thumbnail_img_url
                ? ApiUtils.validateImgUrl({ url: voucher.thumbnail_img_url })
                : Assets.iconTokopedia
            }
            className="voucher-image"
            alt="voucher_image"
          />
        </Col>
        <Col xs={6} sm={6} md={6} className="voucher-list-detail">
          <div className="voucher-list-title">{voucher.name}</div>
          <div className="voucher-list-info">
            <div dangerouslySetInnerHTML={{ __html: voucher.description }} />
          </div>
        </Col>
        <Col xs={3} sm={3} md={3} className="redeem-button">
          <Button
            variant="danger"
            className="btn-redeem"
            onClick={() => {
              navigate(voucherPathDetail);
            }}
          >
            Redeem
          </Button>
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

const nearMePage = (props) => {
  const { url_category } = useParams();
  const { reward, getRewardByLocationNearby, categoriesDiscount } = props;

  const [filter, setFilter] = useState({
    category: {
      slug: "",
      name: "",
      sub_categories: [],
    },
    active_filter: "all",
    temp_active_filter: "all",
  });
  const [voucherData, setVoucherData] = useState(
    reward["reward_nearby"] ? reward["reward_nearby"].results : {}
  );
  const [isShow, setIsShow] = useState(false);
  const [dataLocation, setDataLocation] = useState({});

  useEffect(() => {
    getLocation();
  }, []);

  useEffect(() => {
    fetchData();
    if (categoriesDiscount && categoriesDiscount.length > 0) {
      let arr = [...categoriesDiscount];
      let category = arr.find((el) => el.slug === url_category);
      if (category) {
        setFilter({
          ...filter,
          category: category,
        });
      }
    }
  }, [dataLocation]);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setDataLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    }
  };

  const fetchData = async () => {
    let params = {
      lat: dataLocation.latitude,
      lng: dataLocation.longitude,
      category: url_category,
    };
    if (filter.temp_active_filter !== "all") {
      params["sub_category"] = filter.temp_active_filter;
    }
    let response = await getRewardByLocationNearby(params);
    setVoucherData(response?.data?.results);
  };

  const NearMap = (props) => {
    const listMarker = props.data.map((item) => {
      return {
        name: item.name,
        address: item.address,
        position: {
          lat: item.coordinates[1],
          lng: item.coordinates[0],
        },
        url: url_category,
        key: item.reward,
        redirectDetail: true,
      };
    });

    return (
      <ShowGoogleMap
        listMarker={listMarker}
        dataCenter={
          listMarker.length > 0
            ? {
                lat: listMarker[0].position.lat,
                lng: listMarker[0].position.lng,
              }
            : {
                lat: -6.210292305256883,
                lng: 106.83775774543231,
              }
        }
      />
    );
  };

  const handleDrawer = (isSaved) => {
    let tempFilter;
    if (isSaved) {
      tempFilter = {
        ...filter,
        active_filter: filter.temp_active_filter,
      };
      setFilter(tempFilter);
      setTimeout(() => {
        fetchData();
      }, 1000);
    } else {
      tempFilter = {
        ...filter,
        temp_active_filter: filter.active_filter,
      };
      setFilter(tempFilter);
    }
    setIsShow(false);
  };

  return (
    <div className="nearme-page">
      <div className="nearme-header">
        <TopNavigation
          titlePage="Near Me"
          toPath={-1}
          setBorder={true}
          showRightIcon={true}
          iconLeft={Assets.iconBack}
          iconRight={Assets.iconFilter}
          onRightNavClicked={() => setIsShow(true)}
        />
      </div>
      <div className="nearme-map">
        <NearMap data={voucherData} />
      </div>
      <div className="nearme-list">
        <ListGroup>
          {Object.keys(voucherData).length > 0 ? (
            voucherData.map((list, index) => (
              <DiscountItem
                data={list}
                key={`item-${index}`}
                url_category={url_category}
              />
            ))
          ) : (
            <div className="nearby-data-not-found"> Data Not Found </div>
          )}
        </ListGroup>
      </div>
      <Drawer
        open={isShow}
        onClose={() => setIsShow(false)}
        direction="right"
        size={400}
        enableOverlay={false}
        overlayColor={"#ffffff"}
      >
        <HeaderLayout
          key="header-voucher-point"
          title="Filter categories by"
          leading={<DefaultLeading onClick={() => handleDrawer(false)} />}
          actions={
            <div className="text-btn" onClick={() => handleDrawer(true)}>
              Done
            </div>
          }
        />
        <ListGroup>
          {filter.category.sub_categories && (
            <ListGroup.Item
              active={filter.temp_active_filter === "all"}
              onClick={() =>
                setFilter({ ...filter, temp_active_filter: "all" })
              }
            >
              All
            </ListGroup.Item>
          )}
          {filter.category.sub_categories &&
            filter.category.sub_categories.map((item, index) => (
              <ListGroup.Item
                key={`list-item-${index}`}
                active={filter.temp_active_filter === item.slug}
                onClick={() =>
                  setFilter({ ...filter, temp_active_filter: item.slug })
                }
              >
                {item.name}
              </ListGroup.Item>
            ))}
          {/* if sub categories not found */}
          {!filter.category.sub_categories && (
            <ListGroup.Item>Filter not available</ListGroup.Item>
          )}
        </ListGroup>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  reward: state.RewardSM,
  categoriesDiscount: state.RewardSM.categoriesDiscount,
});

const mapDispatchToProps = (dispatch) => ({
  getRewardByLocationNearby: dispatch.RewardSM.getRewardByLocationNearby,
});

export default connect(mapStateToProps, mapDispatchToProps)(nearMePage);
